import {Apartment, FilterAltRounded, PersonAdd, ReplayRounded, SearchRounded} from '@mui/icons-material';
import {Box, Button, Grid, IconButton, Menu, MenuItem, Paper, Stack, TextField, useTheme} from '@mui/material';
import {AgGridReact} from 'ag-grid-react';
import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import AgGridCustomTable from '../../../../../util/component/AgGridCustomTable';
import SectionHeader from '../../../../../util/component/SectionHeader';
import {ColDef, GridOptions, IServerSideGetRowsParams} from 'ag-grid-community';
import {Controller, useForm} from 'react-hook-form';
import {useRecoilState} from 'recoil';
import {useAgGridLocale} from '../../../../../config/globalConfig';
import {CUSTOMER_CREATE_SELECTED, CUSTOMER_SELECTED, STEPPER_STATE} from '../../../service/MobilityVoucherRecoil';
import {useVoucherActions} from '../../../service/useMobilityVoucherAction';
import {CustomerAdvancedFilters, CustomerInputGetAll} from '../../../interfaces/Customer';
import ContentBody from '../../../component/common/ContentBody';
import {GlobalContext} from '../../../../../util/state/GlobalContextProvider';
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {snackbarTypes} from '../../../../../util/state/globalVariables';
import ViewCustomerBase from '../../../../customerbase/page/ViewCustomerBase';

const CustomerSearchStep = (props: any) => {
  const { t } = useTranslation(['mobilityvoucher']);
  const agGridLocale = useAgGridLocale();
  const { globalData, dispatchGlobalData } = useContext(GlobalContext);
  const theme = useTheme();
  const { getCustomer } = useVoucherActions();
  const gridRef = useRef<AgGridReact>(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [activeStep, setActiveStep] = useRecoilState(STEPPER_STATE);
  const [custSelect, setCustSelect] = useRecoilState(CUSTOMER_SELECTED);
  const [showExtraFilters, setShowExtraFilters] = useState(false);
  const [creationOf, setCreationOf] = useRecoilState(CUSTOMER_CREATE_SELECTED);
 
  

  const validationSchema = yup.object().shape({
    cbCustomerId: yup.string().nullable(true).trim(),
    taxCode: yup.string().nullable(true).trim(),
    vatNumber: yup.string().nullable(true).trim(),
    drvLicenceNumber: yup.string().nullable(true).trim(),
    firstName: yup.string().nullable(true).trim(),
    lastName: yup.string().nullable(true).trim(),
    companyName: yup.string().nullable(true).trim(),
    email: yup
    .string().nullable(true).trim()
    .email(t('message.validation.emailNotValid'))
  })

  

  const form = useForm<CustomerAdvancedFilters>({
    defaultValues: {
      taxCode: "",
      vatNumber: "",
      cbCustomerId: "",
      email: "",
      firstName: "",
      lastName: "",
      companyName: ""
    },
    resolver: yupResolver(validationSchema)
  })
   
  const defaultValues = {
    taxCode: "",
    vatNumber: "",
    drvLicenceNumber: "",
    cbCustomerId: "",
    email: "",
    firstName: "",
    lastName: "",
    companyName: ""
  };
  const [filters, setFilters] = useState<CustomerAdvancedFilters>(defaultValues);
  const [searchInput, setSearchInput] = useState("");
  const [changeComp, setChangeComp] = useState<boolean>(true);
  const [anchorEl, setAnchorEl] = useState(null);


  const handleOpen = (event:any) => {
		setAnchorEl(event.currentTarget);
	};

  const handleCloseMenu = () => {
		setAnchorEl(null);
	};
  

  function createDatasource(filters: CustomerAdvancedFilters) {
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        let filterTemp: CustomerInputGetAll = { ...filters };
        filterTemp.start = params.request.startRow ? params.request.startRow : 0;
        filterTemp.limit = (params.request.endRow ? params.request.endRow : 10) - filterTemp.start;
        filterTemp.sort = params.request.sortModel.length === 0 ? null : params.request.sortModel[0].colId;
        filterTemp.order = params.request.sortModel.length === 0 ? null : params.request.sortModel[0].sort;
        filterTemp.search = searchInput;
        try {
          let data = await getCustomer(filterTemp);
          let totEl = parseInt(data.totalElements, 10)
          params.success({
            rowData: data.content as any,
            rowCount: totEl
          });
          data.totalElements === '0' && params.api.showNoRowsOverlay();
        } catch (e) {
          params.fail();
          params.api.hideOverlay();
        }
      }
    };
  }

  const columns: ColDef[] = [
    {field: 'firstName', headerName: t('customer_table.firstName'),
      checkboxSelection: true,
      lockPosition: true
    },
    {field: 'lastName', headerName: t('customer_table.lastName'),
    },
    {field: 'companyName', headerName: t('customer_table.companyName')},
    {field: 'siren', headerName: t('customer_table.siren')},
    {field: 'taxCode', headerName: t('customer_table.taxCode')},
    {field: 'vatNumber', headerName: t('customer_table.vatNumber')},
    {field: 'email', headerName: t('customer_table.email')}

  ];

  const onSelectionChanged = () => {
    const selectedRows = gridOptions.api!.getSelectedRows();
    if (selectedRows.length) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  const gridOptions: GridOptions = {
    rowSelection: 'single',
    suppressRowClickSelection: true,
    domLayout: 'autoHeight',
    rowModelType: 'serverSide',
    pagination: true,
    paginationPageSize: 10,
    cacheBlockSize: 10,
    defaultColDef: {
      sortable: false,
      resizable: true,
      wrapHeaderText: true
    },
    columnDefs: columns,
    localeText: agGridLocale,
    onSelectionChanged: onSelectionChanged,
    onGridReady: (params) => {
      params.api.setServerSideDatasource(createDatasource(filters));
    },
    serverSideDatasource: createDatasource(filters)
  };

  const onFormSubmit = (data: any) => {
    gridRef.current?.api.deselectAll();
    setFilters(data);
    setShowExtraFilters(false);
    gridRef?.current?.api?.setServerSideDatasource(createDatasource(filters));
  };

  const onErrors = (errors: any) => console.error(errors);

  const handleNext = async () => {
    if (!gridRef.current?.api.getSelectedRows()[0]?.email) {
      dispatchGlobalData({
        type: 'SET_SNACKBAR',
        payload: {
          snackbar: {
            message: t('mobilityvoucher:message.emailStepper'),
            type: snackbarTypes.warning,
            show: true,
            autoClose: true,
          }
        }
      });
    } else if (
      (!gridRef.current?.api.getSelectedRows()[0].billingAddress?.country || gridRef.current?.api.getSelectedRows()[0].billingAddress?.country.trim().length == 0) ||
      (!gridRef.current?.api.getSelectedRows()[0].billingAddress?.city || gridRef.current?.api.getSelectedRows()[0].billingAddress?.city.trim().length == 0) ||
      (!gridRef.current?.api.getSelectedRows()[0].billingAddress?.zipCode || gridRef.current?.api.getSelectedRows()[0].billingAddress?.zipCode.trim().length == 0) ||
      (!gridRef.current?.api.getSelectedRows()[0].billingAddress?.street || gridRef.current?.api.getSelectedRows()[0].billingAddress?.street.trim().length == 0)
      ) {
      dispatchGlobalData({
        type: 'SET_SNACKBAR',
        payload: {
          snackbar: {
            message: t('mobilityvoucher:message.billingAddressStepper'),
            type: snackbarTypes.warning,
            show: true,
            autoClose: true,
          }
        }
      });
    } else if (
        !gridRef.current?.api.getSelectedRows()[0].roles.includes("CRM000")
    ) {
      dispatchGlobalData({
        type: 'SET_SNACKBAR',
        payload: {
          snackbar: {
            message: t('mobilityvoucher:message.rolesStepper'),
            type: snackbarTypes.warning,
            show: true,
            autoClose: true,
          }
        }
      });
    } else if (!gridRef.current?.api.getSelectedRows()[0].bpCode) {
      dispatchGlobalData({
          type: 'SET_SNACKBAR',
          payload: {
            snackbar: {
              message: t('mobilityvoucher:message.sapIdStepper'),
              type: snackbarTypes.warning,
              show: true,
              autoClose: true,
            }
          }
      });
    } else {
      setCustSelect(gridRef.current?.api.getSelectedRows());
      setActiveStep((prevActiveStep: number) => prevActiveStep + 1);
    }
    
  };
  const handleCancel = async () => {
    setActiveStep((prevActiveStep: number) => 0);
  };

  const resetForm = () => {
    form.reset();
    setShowExtraFilters(false)
    onFormSubmit({})
  }

  useEffect(() => {
    gridRef?.current?.api?.setServerSideDatasource(createDatasource(filters));
  }, [filters]);

  // const navigate = useNavigate();

  
  const addCustomer = () => { 
    setCreationOf('person')
    setChangeComp(false)
    handleCloseMenu()
  }

  const addOrganization = () => {  
    setCreationOf('organization')  
    setChangeComp(false)
    handleCloseMenu()
  }

  const stepperBack = async () => {
    setChangeComp(true)
  };
  
  const onCustomerSubmit = useCallback((e: any) => {
    const  body = {
      taxCode: "",
      vatNumber: "",
      siren: "",
      cbCustomerId: e.cbCustomerId,
      email: "",
      firstName: "",
      lastName: "",
      companyName: ""
    }
    getCustomer(body).then(function(result) {
      setCustSelect(result.content);
      setActiveStep((prevActiveStep: number) => prevActiveStep + 1);
    });
    
  }, []);

  const onCloseFilter = () => {
    form.resetField("companyName");
    form.resetField("vatNumber");
    form.resetField("cbCustomerId");
}
  
  const toolbar = {
    renderActions: () =>
        <>
          <Box>
															<Button
																sx={{mx: theme.spacing(0.5)}}
																aria-controls={`menu-actions-customer`}
																aria-haspopup="true"
																size='smallPlus'
																aria-expanded={Boolean(anchorEl)}
																onClick={(event) => handleOpen(event)}
                                startIcon={<LibraryAddIcon />}
																>
																{t("stepper.add_new_customer")}
															</Button>

															<Menu
															id={`menu-actions-customer`}
															anchorEl={anchorEl}
															open={Boolean(anchorEl)}
															onClose={handleCloseMenu}
															>
																<MenuItem onClick={addCustomer}>
                                  <IconButton>
																		<PersonAdd />
																	</IconButton>
                                  {t("stepper.add_new_person")}
																</MenuItem>

																<MenuItem onClick={addOrganization}>
																	<IconButton>
																		<Apartment />
																	</IconButton>
                                  {t("stepper.add_new_organization")}
																</MenuItem>

															</Menu>
														</Box>
          {/* <Button onClick={addCustomer} size='smallPlus' startIcon={<LibraryAddIcon />}> 
            {t("stepper.add_new_customer")}
          </Button> */}
        </>

}

  return (
  <>
  { changeComp ?
    <>
      <Paper elevation={1} sx={{ padding: "", margin: "18px" }}>
        <SectionHeader title={t('stepper.steps.title2')}
          subtitle={t('stepper.steps.subtitle2')} />

          <ContentBody>
          <Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
      
        <form onSubmit={form.handleSubmit(onFormSubmit, onErrors)} noValidate>
          <Grid sx={{ padding: "16px" }} alignItems="center" container spacing={2}>
            <Grid item xs={3}>
              <Controller
                  name='firstName'
                  control={form.control}
                  render={({ field: { ref, ...field }, fieldState }) => (
                      <TextField
                          label={t('filterBox.firstName')}
                          placeholder={t('filterBox.firstName')}
                          fullWidth
                          defaultValue={''}
                          value={field.value}
                          onChange={field.onChange}
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                      >
                      </TextField>
                  )}
              />
            </Grid>
            <Grid item xs={3}>
              <Controller
                name='lastName'
                control={form.control}
                render={({ field: { ref, ...field }, fieldState }) => (
                  <TextField
                    label={t('filterBox.lastName')}
                    placeholder={t('filterBox.lastName')}
                    fullWidth
                    defaultValue={''}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Controller
                name='taxCode'
                control={form.control}
                render={({ field: { ref, ...field }, fieldState }) => (
                  <TextField
                    label={t('filterBox.taxCode')}
                    placeholder={t('filterBox.taxCode')}
                    fullWidth
                    defaultValue={''}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                  </TextField>
                )}
              />
            </Grid>



            <Grid item lg={3} md={6} xs={12}>
                <Stack direction="row" alignItems="center" justifyContent="end" columnGap={2}>
                    <Button variant="text" startIcon={<ReplayRounded/>} onClick={resetForm}>
                        {t("searchTooltip.clearFilters")}
                    </Button>
                    
                    
                        <Button variant="text" startIcon={<FilterAltRounded />}
                            onClick={()=> {
                                setShowExtraFilters(!showExtraFilters);
                            }}
                        >
                        {   showExtraFilters ? t("searchTooltip.closeFilters") : t("searchTooltip.filters")}   
                        </Button>
                    
                    
                        <Button type="submit" size="icon" color="accent">
                            <SearchRounded/>
                        </Button>
                </Stack>
            </Grid>
          </Grid>
          {showExtraFilters && (
          <>
          <Grid sx={{ padding: "16px" }} justifyContent={'center'} alignContent={'center'} container spacing={2}>
            <Grid item xs={3}>
              <Controller
                  name='email'
                  control={form.control}
                  render={({ field: { ref, ...field }, fieldState }) => (
                      <TextField
                          label={t('filterBox.email')}
                          placeholder={t('filterBox.email')}
                          fullWidth
                          defaultValue={''}
                          value={field.value}
                          onChange={field.onChange}
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                      >
                      </TextField>
                  )}
              />
            </Grid>
            <Grid item xs={3}>
              <Controller
                name='companyName'
                control={form.control}
                render={({ field: { ref, ...field }, fieldState }) => (
                  <TextField
                    label={t('filterBox.companyName')}
                    placeholder={t('filterBox.companyName')}
                    fullWidth
                    defaultValue={''}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Controller
                name='vatNumber'
                control={form.control}
                render={({ field: { ref, ...field }, fieldState }) => (
                  <TextField
                    label={t('filterBox.vatNumber')}
                    placeholder={t('filterBox.vatNumber')}
                    fullWidth
                    defaultValue={''}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={3}>
              <Controller
                name='cbCustomerId'
                control={form.control}
                render={({ field: { ref, ...field }, fieldState }) => (
                  <TextField
                    label={t('filterBox.customerId')}
                    placeholder={t('filterBox.customerId')}
                    fullWidth
                    defaultValue={''}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={3}>
            </Grid>
          </Grid>
          </>
          )}

        </form>
        </Paper>
        </ContentBody>
        <AgGridCustomTable gridOptions={gridOptions} gridRef={gridRef} toolbar={toolbar} />
      </Paper>

      <Grid sx={{ margin: '18px' }} item xs={12} display={"flex"} justifyContent={"flex-end"} mt={3}>
        <Button onClick={handleCancel} size='medium' variant="outlined" sx={{ mr: 1 }}> {t("buttons.back")} </Button>
        <Button disabled={isDisabled} onClick={handleNext} size='medium'> {t("stepper.next")}</Button>
      </Grid>
      {/* <AddCustomerDialog  open={openDialog} handleClose={() => {
                setOpenDialog(false);
      }}/> */}
    </>
   
  :
      <>
      <Paper elevation={1} sx={{ padding: "", margin: "18px" }}>
          <ViewCustomerBase creationOf={creationOf} onCustomerSubmit={onCustomerSubmit}/> 
      </Paper>
      <Grid sx={{ margin: '18px' }} item xs={12} display={"flex"} justifyContent={"flex-end"} mt={3}>
        <Button onClick={stepperBack} size='medium' variant="outlined" sx={{ mr: 1 }}> {t("stepper.back")} </Button>
      </Grid>
      </>
  }
  </>
  );
};

export default CustomerSearchStep;